import ApiService from '@/common/api.service'
import { getDataVersion } from '../utils'

/* eslint-disable */
const getDefaultState = () => {
  return {
  }
}

const state = getDefaultState()

const getters = {
}

const mutations = {
}

const actions = {
  fetchAll({ rootState }, queryParams) {
    return new Promise((resolve, reject) => {
      queryParams.dataVersion = getDataVersion(rootState)
      ApiService.get('PresetMixedModePeriod/pagination', queryParams, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },
  
  fetch({ rootState }, queryParams) {
    return new Promise((resolve, reject) => {
      ApiService.get(`PresetMixedModePeriod/${queryParams.id}`, queryParams, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },

  save({ rootState }, queryParams) {
    return new Promise((resolve, reject) => {
      queryParams.dataVersion = getDataVersion(rootState)
      ApiService.post('PresetMixedModePeriod', queryParams, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },

  remove({ rootState }, queryParams) {
    return new Promise((resolve, reject) => {
      ApiService.get(`PresetMixedModePeriod/delete/${queryParams.id}`, {}, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
